"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const Loading = () => (react_1.default.createElement(react_native_1.View, { style: styles.loading },
    react_1.default.createElement(react_native_1.ActivityIndicator, { size: 32, color: "rgb(0,0,255)" })));
exports.default = Loading;
const styles = react_native_1.StyleSheet.create({
    loading: {
        alignItems: 'center',
        flex: 1,
        justifyContent: 'center',
    },
});
